import React from "react";
import { colors } from "../../../designSystem/colors/color";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { SelectField } from "../../../designSystem/formField/SelectField";
import { Icon, IconSize, IconSizes, iconName, iconNames } from "../../../designSystem/icons/Icons";
import { DesignSystemOverviewLayout, DesignSystemSection, DesignSystemSectionRow } from "../DesignSystemHelpers";
import { ActionPointCounterCompositeIcon, ActionPointSummaryCounterCompositeIcon } from '../../../designSystem/compositeComponents/compositeIcons/ActionPointCounterCompositeIcon';
import { AgendaItemCounterCompositeIcon } from "../../../designSystem/compositeComponents/compositeIcons/AgendaItemCounterCompositeIcon";
import { FileExtensionIcon } from "../../../designSystem/FileExtensionIcon";


const fileExtensionExamples = [
    'example.csv',
    'example.xls',
    'example.xlsx',
    'example.mov',
    'example.mp4',
    'example.gif',
    'example.jpg',
    'example.jpeg',
    'example.png',
    'example.pdf',
    'example.txt',
    'example.rtf',
    'example.doc',
    'example.docx',
];

export const IconOverview = (): JSX.Element => {
    return (
        <DesignSystemOverviewLayout>
            <DesignSystemSection title="FileExtensionIcon">
                <DesignSystemSectionRow title="">
                    {fileExtensionExamples.map(example =>
                        <Flex key={example} alignItems="center" gap={8}>
                            <FileExtensionIcon filename={example} />
                            <span>{example.substring(example.lastIndexOf('.') + 1)}</span>
                        </Flex>
                    )}
                </DesignSystemSectionRow>
            </DesignSystemSection>

            <DesignSystemSection title="Icon colors">
                <DesignSystemSectionRow title=""> 
                    <Flex>
                        <Icon name="facility_kitchen" color={colors.icon.active} />
                        <span>active</span>
                    </Flex>
                    <Flex>
                        <Icon name="facility_kitchen" color={colors.icon.default} />
                        <span>default</span>
                    </Flex>
                    <Flex>
                        <Icon name="facility_kitchen" color={colors.icon.disabled} />
                        <span>disabled</span>
                    </Flex>
                    <Flex>
                        <Icon name="facility_kitchen" color={colors.icon.error} />
                        <span>error</span>
                    </Flex>
                    <Flex>
                        <Icon name="facility_kitchen" color={colors.icon.info} />
                        <span>info</span>
                    </Flex>
                    <Flex>
                        <Icon name="facility_kitchen" color={colors.icon.passive} />
                        <span>passive</span>
                    </Flex>
                    <Flex>
                        <Icon name="facility_kitchen" color={colors.icon.pending} />
                        <span>pending</span>
                    </Flex>
                    <Flex>
                        <Icon name="facility_kitchen" color={colors.icon.success} />
                        <span>success</span>
                    </Flex>
                    <Flex>
                        <Icon name="facility_kitchen" color={colors.icon.warning} />
                        <span>warning</span>
                    </Flex>
                </DesignSystemSectionRow>
            </DesignSystemSection>
            
            <DesignSystemSection title="All icons">
                <SvgDemo />
            </DesignSystemSection>

            <DesignSystemSection title="CompositeIcons">
                <DesignSystemSectionRow title="ActionPointCounterCompositeIcon" >
                    
                    <ActionPointCounterCompositeIcon actionpoints={[]} />
                    
                    <ActionPointCounterCompositeIcon actionpoints={[
                        { done: false, deadline:null }
                    ]} />
                    
                    <ActionPointCounterCompositeIcon actionpoints={[
                        { done: false, deadline:null },
                        { done: true, deadline:new Date(Date.now() + 1000 * 60 * 60) }
                    ]} />

                    <ActionPointCounterCompositeIcon actionpoints={[
                        { done: false, deadline:new Date(Date.now() - 1000 * 60 * 60) }
                    ]} />

                    <ActionPointCounterCompositeIcon actionpoints={[
                        { done: true, deadline:null },
                        { done: true, deadline:new Date(Date.now() - 1000 * 60 * 60) },
                        { done: false, deadline:new Date(Date.now() - 1000 * 60 * 60) }
                    ]} />

                    <ActionPointCounterCompositeIcon actionpoints={[
                        { done: true, deadline:null },
                        { done: true, deadline:new Date(Date.now() - 1000 * 60 * 60) },
                        { done: false, deadline:new Date(Date.now() - 1000 * 60 * 60) },
                        { done: false, deadline:new Date(Date.now() - 1000 * 60 * 60) }
                    ]} />

                    <ActionPointCounterCompositeIcon actionpoints={[
                        { done: true, deadline:null }
                    ]} />

                    <ActionPointCounterCompositeIcon actionpoints={[
                        { done: true, deadline:null },
                        { done: true, deadline:new Date(Date.now() - 1000 * 60 * 60) }
                    ]} />

                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="ActionPointSummaryCounterCompositeIcon">
                    
                    <ActionPointSummaryCounterCompositeIcon 
                        actionPointCount={0}
                        actionPointDoneCount={0}
                        actionPointDeadlinePassedCount={0} />
                    
                    <ActionPointSummaryCounterCompositeIcon 
                        actionPointCount={1}
                        actionPointDoneCount={0}
                        actionPointDeadlinePassedCount={0} />
                    
                    <ActionPointSummaryCounterCompositeIcon 
                        actionPointCount={2}
                        actionPointDoneCount={1}
                        actionPointDeadlinePassedCount={0} />

                    <ActionPointSummaryCounterCompositeIcon 
                        actionPointCount={3}
                        actionPointDoneCount={2}
                        actionPointDeadlinePassedCount={1} />

                    <ActionPointSummaryCounterCompositeIcon 
                        actionPointCount={4}
                        actionPointDoneCount={2}
                        actionPointDeadlinePassedCount={2} />

                    <ActionPointSummaryCounterCompositeIcon 
                        actionPointCount={1}
                        actionPointDoneCount={1}
                        actionPointDeadlinePassedCount={0} />

                    <ActionPointSummaryCounterCompositeIcon 
                        actionPointCount={2}
                        actionPointDoneCount={2}
                        actionPointDeadlinePassedCount={0} />

                </DesignSystemSectionRow>

                <DesignSystemSectionRow title="AgendaItemCounterCompositeIcon">
                    <AgendaItemCounterCompositeIcon agendaitemCount={0} />
                    <AgendaItemCounterCompositeIcon agendaitemCount={1} />
                    <AgendaItemCounterCompositeIcon agendaitemCount={2} />
                </DesignSystemSectionRow>
            </DesignSystemSection>
            
        </DesignSystemOverviewLayout>
    )
}


function SvgDemo():JSX.Element
{
    const colors = ['white', 'black', 'gray', 'lightgray', 'red', 'yellow', 'green', 'blue' ];

    const [settings, setSettings] = React.useState<{
        size:IconSize,
        backgroundColor:string,
        iconColor:string
    }>({size:'small', backgroundColor:'lightgray', iconColor:'black' });

    return (
        <Flex gap={16} flexDirection="column">
            <Flex gap={16}>
                <SelectField 
                    selectedValue={settings.iconColor} 
                    options={colors.map(c => { return {text:c, value:c}})} 
                    onChange={value => setSettings({...settings, iconColor:value})} 
                    label={"Color"}
                />
                <SelectField 
                    selectedValue={settings.backgroundColor} 
                    options={colors.map(c => { return {text:c, value:c}})} 
                    onChange={value => setSettings({...settings, backgroundColor:value})} 
                    label={"Background"}
                />
                <SelectField 
                    selectedValue={settings.size} 
                    options={IconSizes.map(s => { return {text:s, value:s}})} 
                    onChange={value => setSettings({...settings, size:value as IconSize})} 
                    label={"Size"}
                />
            </Flex>
            <div style={{display:'flex', gap:'10px', marginBottom:'10px', alignItems:'center', flexWrap:'wrap'}}>
                {iconNames.map(i => 
                    <SvgDemoIcon key={i} {...settings} icon={i} />
                )}
            </div>
        </Flex>
    );
}

type SvgDemoProps = {
    icon:iconName,
    size:IconSize,
    backgroundColor:string,
    iconColor:string
}
function SvgDemoIcon(props:SvgDemoProps):JSX.Element
{
    return (
        <span style={{padding:'10px', outline:'1px dotted #ccc', backgroundColor:props.backgroundColor}} title={props.icon}>
            <Icon name={props.icon} color={props.iconColor} size={props.size} />
        </span>
    );
}